import React from 'react';
import { Route } from 'react-router-dom';

import UnderConstruction from 'shared/ui/UnderConstruction';
import ContactLinks from 'features/app/pages/ContactLinks';
import QA from 'features/app/pages/QA';
import AddAssortment from 'features/app/pages/assortments/AddAssortment';
import Assortments from 'features/app/pages/assortments/Assortments';
import EditAssortment from 'features/app/pages/assortments/EditAssortment';
import ViewAssortment from 'features/app/pages/assortments/ViewAssortment';
import AddBanner from 'features/app/pages/banners/AddBanner';
import Banners from 'features/app/pages/banners/Banners';
import EditBanner from 'features/app/pages/banners/EditBanner';
import ViewBanner from 'features/app/pages/banners/ViewBanner';
import AddBrand from 'features/app/pages/brands/AddBrand';
import Brands from 'features/app/pages/brands/Brands';
import EditBrand from 'features/app/pages/brands/EditBrand';
import ViewBrand from 'features/app/pages/brands/ViewBrand';
import AddListing from 'features/app/pages/listings/AddListing';
import EditListing from 'features/app/pages/listings/EditListing';
import Listings from 'features/app/pages/listings/Listings';
import ViewListing from 'features/app/pages/listings/ViewListing';
import AddPost from 'features/app/pages/posts/AddPost';
import EditPost from 'features/app/pages/posts/EditPost';
import Posts from 'features/app/pages/posts/Posts';
import ViewPost from 'features/app/pages/posts/ViewPost';

export const appRoutes = (
  <Route path='app'>
    <Route index element={<UnderConstruction />} />

    <Route path='assortments' element={<Assortments status='active' key='activeAssortments' />}>
      <Route path='active' element={<Assortments status='active' key='activeAssortments' />} />
      <Route path='catalog' element={<Assortments status='catalog' key='catalogAssortments' />} />
      <Route path='archived' element={<Assortments status='archived' key='archivedAssortments' />} />
      <Route path='new' element={<AddAssortment />} />
      <Route path=':id'>
        <Route index element={<ViewAssortment />} />
        <Route path='edit' element={<EditAssortment key={new Date().toISOString()} />} />
      </Route>
    </Route>

    <Route path='listings' element={<Listings status='active' />}>
      <Route path='new' element={<AddListing />} />
      <Route path=':id'>
        <Route index element={<ViewListing />} />
        <Route path='edit' element={<EditListing />} />
      </Route>
    </Route>

    <Route path='posts' element={<Posts key='activePosts' status='active' />}>
      <Route path='active' element={<Posts key='activePosts' status='active' />} />
      <Route path='archived' element={<Posts key='archivedPosts' status='archived' />} />
      <Route path='new' element={<AddPost />} />
      <Route path=':id'>
        <Route index element={<ViewPost />} />
        <Route path='delete' element={<ViewPost />} />
        <Route path='edit' element={<EditPost />} />
      </Route>
    </Route>

    <Route path='banners' element={<Banners key='activeBanners' status='active' />}>
      <Route path='active' element={<Banners key='activeBanners' status='active' />} />
      <Route path='archived' element={<Banners archived={true} key='archivedBanners' status='archived' />} />
      <Route path='new' element={<AddBanner />} />
      <Route path=':id'>
        <Route index element={<ViewBanner />} />
        <Route path='edit' element={<EditBanner />} />
      </Route>
    </Route>

    <Route path='brands' element={<Brands />}>
      <Route path='archived' element={<Brands archived={true} />} />
      <Route path='new' element={<AddBrand />} />
      <Route path=':id'>
        <Route index element={<ViewBrand />} />
        <Route path='edit' element={<EditBrand />} />
      </Route>
    </Route>

    <Route path='qas' element={<QA />} />
    <Route path='contact-links' element={<ContactLinks />} />
  </Route>
);

export const appTitles = [
  { path: '/app/assortments/new', title: 'Создание ассортимента' },
  { match: /^\/app\/assortments\/[^/]+\/edit$/, title: 'Редактирование ассортимента' },
  { match: /^\/app\/assortments\/[^/]+$/, title: 'Просмотр ассортимента' },
  { path: '/app/assortments/active', title: 'Активный ассортимент' },
  { path: '/app/assortments/catalog', title: 'Каталог ассортимента' },
  { path: '/app/assortments/archived', title: 'Архив ассортимента' },
  { prefix: '/app/assortments', title: 'Ассортимент' },

  { path: '/app/listings/new', title: 'Создание объявления' },
  { match: /^\/app\/listings\/[^/]+\/edit$/, title: 'Редактирование объявления' },
  { match: /^\/app\/listings\/[^/]+$/, title: 'Просмотр объявления' },
  { prefix: '/app/listings', title: 'Объявления' },

  { path: '/app/posts/new', title: 'Создание поста' },
  { match: /^\/app\/posts\/[^/]+\/edit$/, title: 'Редактирование поста' },
  { match: /^\/app\/posts\/[^/]+$/, title: 'Просмотр поста' },
  { path: '/app/posts/active', title: 'Активные посты' },
  { path: '/app/posts/archived', title: 'Архив постов' },
  { prefix: '/app/posts', title: 'Посты' },

  { path: '/app/banners/new', title: 'Создание баннера' },
  { match: /^\/app\/banners\/[^/]+\/edit$/, title: 'Редактирование баннера' },
  { match: /^\/app\/banners\/[^/]+$/, title: 'Просмотр баннера' },
  { path: '/app/banners/active', title: 'Активные баннеры' },
  { path: '/app/banners/archived', title: 'Архив баннеров' },
  { prefix: '/app/banners', title: 'Баннеры' },

  { path: '/app/brands/new', title: 'Создание бренда' },
  { match: /^\/app\/brands\/[^/]+\/edit$/, title: 'Редактирование бренда' },
  { match: /^\/app\/brands\/[^/]+$/, title: 'Просмотр бренда' },
  { path: '/app/brands/archived', title: 'Архив брендов' },
  { prefix: '/app/brands', title: 'Бренды' },

  { path: '/app/qas', title: 'Вопросы и ответы' },
  { path: '/app/contact-links', title: 'Контактные ссылки' },
  { path: '/app', title: 'Приложение' },
];
